import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ScrollerOptions } from 'primeng/api';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { SelectChangeEvent, SelectModule } from 'primeng/select';

import {
  CommonSelectOption,
  PaginationAndSearch,
} from '@offconon/shared/ui/shared-ui-virtualscroll-multiselect';
import { CommonDropdownAndMultiselectService } from '@offconon/shared/utils/services/common-dropdown-and-multiselect';
@Component({
  selector: 'offconon-shared-ui-virtualscroll-dropdown',
  imports: [
    SelectModule,
    FormsModule,
    TranslateModule,
    FormsModule,
    InputTextModule,
    CommonModule,
    IconFieldModule,
    InputIconModule,
  ],
  templateUrl: './shared-ui-virtualscroll-dropdown.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: `
    offconon-shared-ui-virtualscroll-dropdown {
      .custom-search-input {
        box-shadow:
          inset 0 0 0 1px #3f51b5,
          inset 0 0 0 1px #3f51b5,
          inset 0 0 0 1px #3f51b5,
          inset 0 0 0 1px #3f51b5;
      }
    }
  `,
})
export class SharedUiVirtualscrollDropdownComponent {
  @Input({ required: true }) selectOptions: CommonSelectOption[];
  @Input() pageSize = 50;
  @Input() showClear = false;
  @Input() dataLoading = false;
  @Input() selectedOption: CommonSelectOption | undefined | null;
  @Input() searchString = '';
  @Input() optionTemplate: TemplateRef<any> | undefined;
  @Input() selectedOptionTemplate: TemplateRef<any> | undefined;
  @Input() page = 1;
  @Input() optionHeight = 49;

  @Output() paginationAndSearchOutput = new EventEmitter<PaginationAndSearch>();
  @Output() paginationOutput = new EventEmitter<PaginationAndSearch>();
  @Output() searchOutput = new EventEmitter<PaginationAndSearch>();
  @Output() selectedOptionOutput = new EventEmitter<CommonSelectOption>();
  private commonDropdownAndMultiselectService = inject(CommonDropdownAndMultiselectService);
  virtualScroll$ = this.commonDropdownAndMultiselectService.isLastPage$;
  last = 0;

  virtualScrollOptions: ScrollerOptions = {
    scrollHeight: '300px',
    lazy: true,
    onLazyLoad: (event: any) => {
      this.refreshList(event);
    },
  };

  refreshList(event: any) {
    if (this.last < event.last) {
      this.last = event.last;

      if (event.last % this.pageSize >= this.pageSize - 7) {
        this.page++;
        this.paginationAndSearchOutput.emit({
          page: this.page,
          pageSize: this.pageSize,
          searchString: this.searchString,
        });
        this.paginationOutput.emit({
          page: this.page,
          pageSize: this.pageSize,
          searchString: this.searchString,
        });
      }
    }
  }
  onFilter() {
    this.last = 0;
    this.paginationAndSearchOutput.emit({
      page: 1,
      pageSize: this.pageSize,
      searchString: this.searchString,
      mode: 'search',
    });
    this.searchOutput.emit({
      page: 1,
      pageSize: this.pageSize,
      searchString: this.searchString,
      mode: 'search',
    });
  }

  onChange(event?: SelectChangeEvent) {
    if (event) {
      this.selectedOptionOutput.emit(event.value);
    } else {
      this.selectedOptionOutput.emit(undefined);
    }
  }
}
